import { reduxKey } from './constants';
function getNotificationState(state) {
    return state[reduxKey] || {
        default: []
    };
}
export function getNotificationQueue(state, queue = 'default') {
    return getNotificationState(state)[queue] || [];
}
export function getTopNotification(state, queue = 'default') {
    return getNotificationQueue(state, queue)[0];
}
